module.exports = __webpack_public_path__ + "static/mk8-bg-52d62cc59e0fcae1c2c0b1814df4fcaa.jpg";